/* @ngInject */
export default function ($filter) {
	return {
		link: (scope, element, attributes) => {
			element.text($filter('date')(new Date(), attributes.currentDate));
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/currentDate.js